// App.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import Swal from 'sweetalert2';
import { useAuth } from 'react-oidc-context';
import Routes from './presetation/components/router/Routes';
import './presetation/styles/globals.css';
import axios from 'axios';

function App() {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (isAuthenticated && user?.access_token) {
          config.headers['Authorization'] = `Bearer ${user.access_token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, [isAuthenticated, user]);


  useEffect(() => {
    Swal.close();
  }, [location]);

  return (
    <div className="App" data-testid="app">
      <Routes />
    </div>
  );
}

export default App;
